import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { colors, typography } from '@mehilainen/mds-tokens';
import { baseTypography } from '@mehilainen/mds-tokens/typography';
import { autocompleteClasses, chipClasses, inputBaseClasses, outlinedInputClasses, Stack, } from '@mui/material';
// NOTE: Do not import these from lib root (src/index)! Will cause circular deps
import { AngleBottom, CheckCircleSolid } from '../../../icons';
const selectedOptionIconClassname = 'mds-autocomplete-selected-icon';
export const getThemeAutocomplete = (tokens) => ({
    MuiAutocomplete: {
        defaultProps: {
            popupIcon: _jsx(AngleBottom, {}),
            disableClearable: true,
            disableCloseOnSelect: true,
            getOptionLabel: (option) => typeof option === 'string' ? option : option.label,
            // TODO: Export this if data form customization is needed
            renderOption: (liProps, option, state) => (_jsx("li", Object.assign({}, liProps, { children: _jsxs(Stack, { direction: "row", justifyContent: "space-between", width: "100%", children: [typeof option === 'string' ? option : option.label, state.selected && (_jsx(CheckCircleSolid, { className: selectedOptionIconClassname }))] }) }))),
            // MATTI-TODO: what to render when no-options
        },
        styleOverrides: {
            root: {
                [`& .${outlinedInputClasses.root}.${inputBaseClasses.sizeSmall}`]: {
                    paddingLeft: tokens.uiElementInputFields.common.paddingLeft + 'px',
                    [`& > .${autocompleteClasses.input}`]: {
                        paddingLeft: 0,
                    },
                },
            },
            popper: {
                animation: `200ms linear fadeIn`,
                /* Shadow 200 */
                boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.08)',
                '@keyframes fadeIn': {
                    '0%': {
                        opacity: 0,
                    },
                    '100%': {
                        opacity: 1,
                    },
                },
            },
            inputRoot: {
                paddingRight: '39px',
            },
            listbox: {
                padding: 0,
                '& > *:nth-of-type(even)': {
                    backgroundColor: colors.Gray100,
                },
            },
            option: () => ({
                fontSize: tokens.uiElementTypography.dropdownRow,
                fontWeight: typography.baseTypography.weight.Regular,
                lineHeight: typography.baseTypography.height.Medium,
                minHeight: '32px',
                padding: '4px 16px',
                [`& .${selectedOptionIconClassname}`]: {
                    color: colors.Gray800,
                    fontSize: baseTypography.size.icon[200].px,
                },
                '&.Mui-focused': {
                    backgroundColor: colors.Gray200,
                },
                '&[aria-selected="true"]': {
                    fontWeight: typography.baseTypography.weight.Medium,
                    backgroundColor: 'inherit',
                    [`& .${selectedOptionIconClassname}`]: {
                        color: colors.Primary500,
                    },
                },
            }),
            tag: {
                height: '24px',
                color: colors.Gray800,
                borderColor: colors.Gray500,
                borderRadius: '16px',
                borderStyle: 'solid',
                borderWidth: '1px',
                backgroundColor: colors.Gray100,
                fontSize: typography.baseTypography.size[200].rem,
                fontWeight: typography.baseTypography.weight.Medium,
                lineHeight: typography.baseTypography.height.Small,
                [`.${chipClasses.deleteIcon}`]: {
                    color: colors.Gray800,
                    fontSize: 'inherit',
                },
            },
        },
    },
});
